module.exports = __webpack_public_path__ + "img/img20.a4a2e6da.png";